import { Metadata } from "types/Metadata";


/** AAL = allarmi analogici, DAL = allarmi digitali: sono le due tabelle di SETTINGS */
export const ALARM_KINDS: AlarmKind[] = ["AAL", "DAL"];


export enum PROPERTIES_TAB {
	PROPERTIES = "pro",
	ANALOG = "ana",
	DIGITAL = "dig"
}
/** prefisso del nome variabile: AAL = analogico, DAL = digitale */

export type AlarmKind = "AAL" | "DAL";
/** riga di tabella: tutte le variabili di un allarme (stesso INDEX) di un componente */

export interface AlarmRow {
	index: string;
	typeName: string;
	/** mappa PROPERTY -> Metadata della variabile */
	props: { [property: string]: Metadata; };
}

